import { Anchor, AnchorProps, createStyles } from "@mantine/core";
import { PolymorphicComponentProps } from "@mantine/utils";

type RpiLinkVariant = "default" | "underline" | "inherit" | "unstyled";

export interface RpiLinkProps {
  variant?: RpiLinkVariant;
}

const useRpiLinkStyles = createStyles<"root", Required<RpiLinkProps>>((theme, { variant }) => {
  switch (variant) {
    case "underline":
      return {
        root: {
          ...theme.other.fontTypes.p3,
          fontWeight: theme.other.fontWeights.regular,
          color: theme.colors.brand[5],
          textDecoration: "underline",
        },
      };

    case "inherit":
      return {
        root: {
          fontFamily: "inherit",
          fontWeight: "inherit",
          fontSize: "inherit",
          color: "inherit",
          lineHeight: "inherit",

          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      };

    case "unstyled":
      return {
        root: { color: "inherit" },
      };

    default:
      return {
        root: {
          ...theme.other.fontTypes.link,
          fontWeight: theme.other.fontWeights.bold,
          color: theme.colors.calm[5],
          "&:hover": {
            textDecoration: "underline",
          },
        },
      };
  }
});

export function RpiLink<C = "a">({
  variant = "default",
  className,
  ...props
}: PolymorphicComponentProps<C, Omit<AnchorProps, "variant">> & RpiLinkProps) {
  const { classes, cx } = useRpiLinkStyles({ variant });

  // @ts-expect-error legacy type issues
  return <Anchor unstyled className={cx(classes.root, className)} {...props} />;
}
